var i = /* @__PURE__ */ function(t) {
  return t.distechLight = "distechLight", t.distechDark = "distechDark", t.atriusLight = "atriusLight", t.atriusDark = "atriusDark", t.dlnLight = "dlnLight", t;
}({});
export {
  i as THEME,
  i as default
};
